import { render, staticRenderFns } from "./NewRirekishoPreview.vue?vue&type=template&id=1a033b1a"
import script from "./NewRirekishoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports